<script setup lang="ts">
import type { BrandAppFont } from '../../lib/brandAppFonts'
import PanelGroup from '../PanelGroup.vue'
import FontPicker from './FontPicker.vue'

const { t } = useI18n()

defineProps<{
  fontHeading?: BrandAppFont | null
  fontBody?: BrandAppFont | null
  hideTitle?: boolean
}>()

const emit = defineEmits<{
  'update:fontHeading': [value: BrandAppFont | null]
  'update:fontBody': [value: BrandAppFont | null]
}>()
</script>

<template>
  <PanelGroup :title="hideTitle ? undefined : t('pages.loyaltySupports.webapp.editor.design.typography.title')">
    <div class="flex flex-col gap-4">
      <FontPicker
        id="brandApp.fontHeading"
        :label="t('pages.loyaltySupports.webapp.editor.design.typography.headings')"
        :model-value="fontHeading"
        @update:model-value="emit('update:fontHeading', $event)"
      />
      <FontPicker
        id="brandApp.fontBody"
        :label="t('pages.loyaltySupports.webapp.editor.design.typography.body')"
        :model-value="fontBody"
        @update:model-value="emit('update:fontBody', $event)"
      />
    </div>
  </PanelGroup>
</template>
